import React, { Component } from 'react'
import Select from 'react-select'

class RAG extends Component {
    constructor() {
        super()
        this.state = {
            RAGList:[ {"label":"Green","value":"Green"},{"label":"Amber","value":"Amber"},{"label":"Red","value":"Red"}]
        }
        this.isComponentStillMounted = true
    }

   

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    

    render() {
       return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={this.state.RAGList}
                placeholder="Select RAG"
                onChange={(e) => { (e) ? this.props.ragChange(e) : this.props.ragChange([])}}
                />
            </div>
        )
    }
}

export default RAG


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/DropDowns/RAG.js